module.exports = __webpack_public_path__ + "static/media/BlingV3_02.685033fe.png";